export enum TypeBtn {
  CurrentDate = 2,
  Pending = 3,
  OtherDate = 1
}
